import types from './types';

const INITIAL_STATE = {
  isFetching: false,
  isFetchingCount: false,

  result: [],
};

const eligibilityCarePlanReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {

    case types.GET_CARE_PLAN_DOCUMENTS_REQUEST:
      return {
        ...state,
        result: [],
        isFetching: true,
      };

    case types.GET_CARE_PLAN_DOCUMENTS_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetching: false,
      };

    case types.GET_CARE_PLAN_DOCUMENTS_FAILURE:
      return {
        ...state,
        result: [],
        isFetching: false,
      };

    case types.GET_NEW_CARE_PLAN_ITEMS_COUNT_REQUEST:
      return {
        ...state,
        result: [],
        isFetchingCount: true,
      };

    case types.GET_NEW_CARE_PLAN_ITEMS_COUNT_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchingCount: false,
      };

    case types.GET_NEW_CARE_PLAN_ITEMS_COUNT_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingCount: false,
      };

    default:
      return state;
  }
};

export default eligibilityCarePlanReducer;
